import React from 'react'

import { Session } from '../types'

const SessionContext = React.createContext<Session | undefined>(undefined)

export default SessionContext
